var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, Typography } from '@mui/material';
import { userInformation } from '@src/app/helper';
import { handleFocus } from '@src/app/helper/NumberHelpers';
import Activity from '@src/app/pages/JobPage/JobDetail/Activity/Activity';
import { useActivityById, useJob } from '@src/app/pages/JobPage/JobHooks/Job.hooks';
import { useSaldoTeams } from '@src/app/pages/SaldoTeamPage/SaldoTeamHooks/SaldoTeam.hooks';
import DrawerComponent from '@src/components/Atoms/Drawer/Drawer';
import InputFormik from '@src/components/Atoms/Formik/Input/InputFormik';
import { useFormik } from 'formik';
import { Fragment, useEffect, useState } from 'react';
import * as Yup from 'yup';
import JobDetailForm from '../../Job/JobDetailForm';
var JobUpdateFormSchema = Yup.object().shape({
    details: Yup.array().of(Yup.object().shape({
        profilePubId: Yup.string(),
        jobTypePubId: Yup.string(),
        exclusiveStatus: Yup.string(),
        fee: Yup.string(),
        totalPosts: Yup.string(),
        totalFollowers: Yup.string(),
        timeFrame: Yup.string(),
        notes: Yup.string(),
        owningType: Yup.string(),
        boostingType: Yup.string(),
    })),
});
var UpdateJob = function (_a) {
    var _b;
    var isOpen = _a.isOpen, handleClose = _a.handleClose, record = _a.record, totalFeeBundling = _a.totalFeeBundling, id = _a.id, profiles = _a.profiles;
    var socialMedias = JSON.parse(userInformation).socialMedias;
    var updateJob = useJob(undefined, false).updateJob;
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState(), initialFormValues = _d[0], setInitialFormValues = _d[1];
    var teamPubId = JSON.parse(userInformation).teams;
    var activityData = useActivityById(id, { enabled: isOpen }).data;
    var _e = useState({
        page: 1,
        pageSize: 10,
        keyword: '',
        filterBy: "[['team.pubId', '".concat((_b = teamPubId[0]) === null || _b === void 0 ? void 0 : _b.pubId, "']]"),
        initialFilterBy: "[]",
    }), filterSaldoTeam = _e[0], setFilterSaldoTeam = _e[1];
    var saldoTeams = useSaldoTeams(filterSaldoTeam, { enabled: isOpen }).saldoTeams;
    var JobUpdateFormik = useFormik({
        enableReinitialize: true,
        initialValues: initialFormValues,
        validationSchema: JobUpdateFormSchema,
        onSubmit: function (values, _a) {
            var setStatus = _a.setStatus, setSubmitting = _a.setSubmitting;
            return __awaiter(void 0, void 0, void 0, function () {
                var formValues, removeDotsFromKeys, details, totalFeeBundling_1, value, finalFormValue, finalDetails, finalTotalFeeBundling, formData, e_1, error;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, 3, 4]);
                            formValues = __assign({ id: id }, values);
                            removeDotsFromKeys = function (arr, keys) {
                                return arr.map(function (item) {
                                    var updatedItem = __assign({}, item);
                                    // Loop through the specified keys and remove dots
                                    keys.forEach(function (key) {
                                        if (updatedItem[key]) {
                                            updatedItem[key] = updatedItem[key].replace(/\./g, '');
                                        }
                                    });
                                    return updatedItem;
                                });
                            };
                            details = formValues.details, totalFeeBundling_1 = formValues.totalFeeBundling, value = __rest(formValues, ["details", "totalFeeBundling"]);
                            finalFormValue = value;
                            finalDetails = removeDotsFromKeys(details, [
                                'fee',
                                'totalFollowers',
                                'totalPosts',
                            ]);
                            finalTotalFeeBundling = totalFeeBundling_1.toString().replaceAll('.', '') //totalFeeBundling.replace(/\./g, '')
                            ;
                            formData = __assign(__assign({}, finalFormValue), { details: finalDetails, totalFeeBundling: finalTotalFeeBundling });
                            setLoading(true);
                            return [4 /*yield*/, updateJob(formData)];
                        case 1:
                            _b.sent();
                            return [3 /*break*/, 4];
                        case 2:
                            e_1 = _b.sent();
                            error = e_1.response.data;
                            setStatus(error.message);
                            setSubmitting(false);
                            setLoading(false);
                            return [3 /*break*/, 4];
                        case 3:
                            setLoading(false);
                            handleClose();
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
    });
    var handleAdd = function () {
        var newDetails = {
            profilePubId: '',
            jobTypePubId: '',
            exclusiveStatus: '',
            fee: 0,
            totalPosts: 0,
            totalFollowers: 0,
            timeFrame: '',
            notes: '',
            owningType: '',
            boostingType: '',
        };
        setInitialFormValues(function (prevState) { return (__assign(__assign({}, prevState), { details: __spreadArray(__spreadArray([], prevState.details, true), [newDetails], false) })); });
    };
    var handleRemove = function (index) {
        var updatedDetails = __spreadArray([], initialFormValues.details, true);
        updatedDetails.splice(index, 1);
        setInitialFormValues(function (prevState) { return (__assign(__assign({}, prevState), { details: updatedDetails })); });
    };
    useEffect(function () {
        var jobInitialValues = {
            details: record &&
                record.length > 0 &&
                record.map(function (data) {
                    var _a, _b;
                    return ({
                        pubId: data.pubId,
                        profilePubId: data.profile.pubId,
                        jobTypePubId: data.jobType.pubId,
                        exclusiveStatus: data.exclusiveStatus,
                        fee: data.fee,
                        totalPosts: data.totalPosts,
                        totalFollowers: data.totalFollowers,
                        timeFrame: data.timeFrame,
                        notes: data.notes,
                        profileName: data.profile.socialMedia.name,
                        owningType: (_a = data.owningType) !== null && _a !== void 0 ? _a : 'NoOwning',
                        boostingType: (_b = data.boostingType) !== null && _b !== void 0 ? _b : 'NoBoosting',
                    });
                }),
            totalFeeBundling: totalFeeBundling || 0,
        };
        setInitialFormValues(jobInitialValues);
    }, [record, totalFeeBundling]);
    var recordData = __assign(__assign({}, record), { talent: {
            profiles: profiles || [],
        } });
    return (_jsx(DrawerComponent, __assign({ open: isOpen, size: 'LG', handleClose: handleClose, title: 'Update Job' }, { children: _jsx("form", __assign({ className: 'form w-100', onSubmit: JobUpdateFormik.handleSubmit, noValidate: true, id: 'job-process-form' }, { children: record && (_jsxs("div", { children: [initialFormValues &&
                        initialFormValues.details &&
                        initialFormValues.details.length > 0 &&
                        initialFormValues.details.map(function (detail, index) { return (_jsx(Fragment, { children: _jsx(JobDetailForm, { useForm: JobUpdateFormik, index: index, value: detail, removeDetail: handleRemove, record: recordData }) }, index)); }), _jsx("button", __assign({ type: 'button', className: 'btn btn-sm btn-success mb-5', onClick: handleAdd }, { children: "Add New Job Details" })), _jsx(Divider, {}), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Total Fee Bundling', type: 'text', placeholder: 'Total Fee Bundling', name: 'totalFeeBundling', formik: JobUpdateFormik, formatNumber: true, onfocus: handleFocus }) })), _jsx(Divider, {}), _jsx("div", __assign({ className: 'my-5' }, { children: _jsxs(Typography, __assign({ variant: 'h6' }, { children: [_jsx("b", { children: "Sisa Saldo:" }), " Rp. ", saldoTeams === null || saldoTeams === void 0 ? void 0 : saldoTeams.data.total.toLocaleString()] })) })), _jsx(Divider, {}), _jsxs("div", __assign({ className: 'my-5' }, { children: [_jsx(Typography, __assign({ variant: 'h6', className: 'fw-bolder' }, { children: "Aktifitas" })), _jsx(Activity, { datas: activityData, id: id ? id : '' })] })), _jsx(Divider, {}), _jsx("div", __assign({ className: 'my-5' }, { children: _jsxs("div", __assign({ style: { textAlign: 'right' } }, { children: [_jsx("button", __assign({ type: 'button', className: 'btn btn-secondary btn-active-light-primary btn-sm', onClick: handleClose, disabled: JobUpdateFormik.isSubmitting, style: { marginRight: '1rem' } }, { children: "Batal" })), _jsxs("button", __assign({ type: 'submit', id: 'kt_jobtype_submit', className: 'btn btn-primary btn-sm', disabled: JobUpdateFormik.isSubmitting || !JobUpdateFormik.isValid }, { children: [!loading && _jsx("span", __assign({ className: 'indicator-label' }, { children: "Simpan" })), loading && (_jsxs("span", __assign({ className: 'indicator-progress', style: { display: 'block' } }, { children: ["Mohon tunggu...", _jsx("span", { className: 'spinner-border spinner-border-sm align-middle ms-2' })] })))] }))] })) }))] })) })) })));
};
export default UpdateJob;
